"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
/**
 * @deprecated Import from `@emotion/react`
 */
function useHoustonTheme() {
    return (0, react_1.useTheme)();
}
exports.default = useHoustonTheme;
